import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import {NgbCarousel, NgbCarouselConfig} from "@ng-bootstrap/ng-bootstrap";
import {Angulartics2} from "angulartics2";
import { HybridToolsService } from '../../../../core/services/hybrid-tools.service';
declare var $: any;
declare var jQuery: any;

@Component({
  selector: 'app-five-steps',
  templateUrl: './five-steps.component.html',
  styleUrls: ['../participants-resources.scss']
})
export class FiveStepsComponent implements OnInit, AfterViewInit {
  public isStep1Collapsed = false;
  public isStep2Collapsed = false;
  public isStep3Collapsed = false;
  public isStep4Collapsed = false;
  public isStep5Collapsed = false;
  @Input() fundraisingTips: any = [];
  @Input() gettingStartedContent: any;

  @ViewChild('tips', { static: true })
  carousel: NgbCarousel;

  constructor(config: NgbCarouselConfig, private angulartics2: Angulartics2, private hybridToolsService: HybridToolsService) {
    config.interval = 0;
  }

  next() {
   this.carousel.next();
  }
  prev() {
    this.carousel.prev();
  }

  ngOnInit() {
    this.angulartics2.eventTrack.next({
      action: 'View Idea',
      properties: {category: 'Fundraising Toolbox: Get Started'}
    });
  }

  ngAfterViewInit() {
    const that = this;
    $('.first-steps a').each(function (item) {
      $(this).attr('data-link', $(this).attr('href')).removeAttr('href');
      $(this).addClass('link');
      $(this).bind('click', function () {
        that.hybridToolsService.openExternalLink($(this).attr('data-link'));
      });
    });
  }
}
